import { FC, useContext, useState } from 'react';
import { Radar } from 'lucide-react';
import ContextStore from '../hooks/ContextStore';
import RadarPanel from '../components/pricing/RadarPanel';
import './ProductRadar.page.css';

// Product research — separate from Pricing Intelligence on purpose:
// finding what to sell (category watch, winning products, daily sourcing
// picks) vs. pricing what we already sell.
const ProductRadarPage: FC = () => {
  const { contextStore } = useContext(ContextStore);
  const token = contextStore.token;
  const [flash, setFlash] = useState<string | null>(null);
  const show = (msg: string) => { setFlash(msg); setTimeout(() => setFlash(null), 6000); };

  return (
    <div className="pr">
      <div className="pr__head">
        <div className="pr__title-block">
          <div className="pr__title-icon"><Radar size={15} color="#fff" /></div>
          <div>
            <div className="pr__title">Product Radar</div>
            <div className="pr__sub">Product research on Jumia — watch categories, spot winning products, send daily sourcing picks to the team</div>
          </div>
        </div>
      </div>
      <div className="pr__body">
        <RadarPanel token={token} flash={show} />
      </div>
      {flash && (
        <div className={`pr__flash${flash.startsWith('⚠') ? ' pr__flash--bad' : ''}`}>{flash}</div>
      )}
    </div>
  );
};

export default ProductRadarPage;
